<div
    class="layer-button-item"
    [ngClass]="{ 'loading-data': isLoading, 'layer-button-item--active': active }"
    [innerHtml]="label"
></div>
